// extracted by mini-css-extract-plugin
export var boxItems = "_75-1";
export var boxItemsLg = "_75-2";
export var button = "_75-7";
export var buttonHoverless = "_75-9";
export var buttonLg = "_75-8";
export var filterGroupBox = "_75-0";
export var icon = "_75-3";
export var iconSecondary = "_75-6";
export var iconWrapper = "_75-4";
export var iconWrapperLg = "_75-5";
export var truncatedLabel = "_75-a";